import { useMediaQuery } from '@react-hook/media-query';

export function useIsMobile() {
  return useMediaQuery('(max-width: 767px)');
}

export default useIsMobile;
